<script>
import options from './PersonalFundraisingListItem.options'
export default options
</script>

<template>
  <div class="kb-personal-fundraising-list-item">
    <a
      v-if="isLink"
      class="kb-personal-fundraising-list-item__name kb-personal-fundraising-list-item__name--link"
      :href="url"
    >{{ name }}</a>
    <span
      v-else
      class="kb-personal-fundraising-list-item__name"
    >{{ name }}</span>
    <span class="kb-personal-fundraising-list-item__amount">{{ formattedAmount }}</span>
  </div>
</template>
